import type { EnrollCourse201OneOfThreeResult } from './enrollCourse201OneOfThreeResult';

export type EnrollCourse201OneOfThree = {
  /** 에러 코드 */
  errorCode: string;
  /** 실패 사유 */
  reason: string;
  result: EnrollCourse201OneOfThreeResult;
};
